/* REMINDER - Rebuild the server after adding keys from here in server\controllers\app.ts */

export const enum UserSettingsKey {
	VENDOR = 'vendor',
	TEMPLATE_ID = 'templateId',
	SHOW_FIRST_WIZARD = 'show_first_wizard',
	SKIP_YEARLY_UPGRADE_NOTIFICATION = 'skip_yearly_upgrade_notification',
	CARD_EXPIRING_SHOWN_TIMESTAMP = 'card_expiring_shown_timestamp',
	BOARD_SCHEDULE_POPUP_SEEN = 'board_schedule_popup_seen',
	ACTIVITY_SEEN = 'activity_seen',
	SHOW_INVITED_USER_INTRO_VIDEO = 'show_invited_user_intro_video',
	WIZARD_SECOND = 'wizard_second',
	ONBOARDING_TYPE = 'onboarding_type', // value one of: 'regular', 'template', 'autoconnect', '920231_A', '920231_B',
	COLOR_MODE = 'color_mode',
	AFTER_AUTO_TRIAL_POPUP_SEEN = 'after_auto_trial_popup_seen',
	CUSTOM_METRICS_QB_GSHEETS_VIDEO_SEEN = 'custom_metrics_qb_gsheets_video_seen',
	SELECTED_CONNECTION_POPUP_SEEN = 'selected_connection_popup_seen',
	LOOP_PROMO_POPUP_SEEN = 'loop_promo_popup_seen',
	INVITE_USER_BOARD_PROMO_POPUP_SHOWN_TIMESTAMP = 'invite_user_board_promo_popup_shown_timestamp',
	INVITE_USER_SOURCE_PROMO_POPUP_SHOWN_TIMESTAMP = 'invite_user_source_promo_popup_shown_timestamp',
	BEST_VALUE_PLAN_BANNER_COOLDOWN_TIMESTAMP = 'best_value_plan_banner_cooldown_timestamp',
	GUIDED_ONBOARDING_POPUP_START_SEEN = 'guided_onboarding_popup_start_seen',
	PRODUCT_UPDATES_SEEN_TIMESTAMP = 'product_updates_seen_timestamp',
	AI_SUMMARY_BLOCK_USED = 'ai_summary_block_used',
	AI_SUMMARY_AUTOCREATE_POPUP_SEEN = 'ai_summary_autocreate_popup_seen',
	CUSTOM_METRICS_PROMO_POPUP_SEEN = 'custom_metrics_promo_popup_seen',
	GROWTH_TRIAL_OFFER_POPUP_SEEN = 'growth_trial_offer_popup_seen',
	CLIENT_PROMO_BANNER_CLOSED_TIMESTAMP = 'client_promo_banner_closed_timestamp',
	TRIAL_EXPIRED_POPUP_SEEN = 'trial_expired_popup_seen',
	ONBOARDING_SELECT_TOOLS_STARTED = 'onboarding_select_tools_started',
	OKR_OVERVIEW_HIDDEN = 'okr_overview_hidden',
	ONBOARDING_WELCOME_SEEN = 'onboarding_welcome_seen',
	HOME_ATTRIBUTION_QUESTION_CLOSED = 'home_attribution_question_closed',
	ONBOARDING_GENIE_POPUP_SEEN = 'onboarding_genie_popup_seen',
	ONBOARDING_GENIE_ARTIFACTS_POPUP_SEEN = 'onboarding_genie_artifacts_popup_seen',
	ONBOARDING_NEW_NAVIGATION_POPUP_SEEN = 'onboarding_new_navigation_popup_seen',
	ONBOARDING_CHAT_LEAVE_CONFIRM_SEEN = 'onboarding_chat_leave_confirm_seen',
	ONBOARDING_CHAT_THREAD_ID = 'onboarding_chat_thread_id',
	AGENTIC_INTRO_POPUP_SEEN = 'agentic_intro_popup_seen',
	MAIN_NAVIGATION_COLLAPSED = 'main_navigation_collapsed',
	LEGACY_METRICS_BANNER_SEEN = 'legacy_metrics_banner_seen',
	UNVERIFIED_AGENCY_WARNING_DISMISSED = 'unverified_agency_warning_dismissed',
	GENIE_CONNECTORS_PROMO_DISMISSED = 'genie_connectors_promo_dismissed',
	MARKETPLACE_SKILL_SIGNUP = 'marketplace_skill_signup',
	METRIC_MOVER_POPUP_SEEN_SPACES = 'metric_mover_popup_seen_spaces', // comma-separated space ids
	METRIC_MOVER_PUSHAPI_POPUP_SEEN_SPACES = 'metric_mover_pushapi_popup_seen_spaces', // comma-separated space ids

	// COMING SOON WAITLISTS
	COMING_SOON_WAITLIST_AGENTS = 'coming_soon_waitlist_agents',
	COMING_SOON_WAITLIST_MCP_CONNECTORS = 'coming_soon_waitlist_mcp_connectors',

	PROMOTION_GROWTH_2024_POPUP_TRIAL_STARTED_SEEN_TIMESTAMP = 'promotion_growth_2024_popup_trial_started_seen_timestamp',
	PROMOTION_GROWTH_2024_POPUP_TRIAL_ENDED_SEEN = 'promotion_growth_2024_popup_trial_ended_seen',
	PROMOTION_GROWTH_2024_POPUP_DISCOUNT_ENDING_SEEN = 'promotion_growth_2024_popup_discount_ending_seen',
	PROMOTION_GROWTH_2024_POPUP_DISCOUNT_USE_CASES_SEEN = 'promotion_growth_2024_popup_discount_use_cases_seen',
	PROMOTION_GROWTH_2024_BANNER_DISCOUNT_SNOOZE_TIMESTAMP = 'promotion_growth_2024_banner_discount_snooze_timestamp',
	PROMOTION_RECENTLY_DELETED_TIMESTAMP = 'promotion_recently_deleted_timestamp',

	// TOURS
	CLIENT_PERFORMANCE = 'client_performance',
	CLIENTS_SETUP = 'clients_setup',
	FIRST_BOARD_EDIT = 'first_board_edit',
	FIRST_BOARD_SHARE = 'first_board_share',
	GOALS_DATE_RANGES = 'goals_date_ranges',
	GOALS_FAVORITES = 'goals_favorites',
	METRICS_SOURCES = 'metrics_sources',
	ONBOARDING_SOURCE = 'onboarding_source',
	CUSTOM_METRICS_POPUP_QB = 'custom_metrics_popup_qb',
	CUSTOM_METRICS_POPUP_SCRIPT = 'custom_metrics_popup_script',
	QB_GSHEETS_VIDEO = 'qb_gsheets_video',
	QB_SHEETS = 'qb_sheets',
	WHITE_LABELING_PAYING_CUSTOMERS_PROMO = 'white_labeling_paying_customers_promo',
	WIZARD_DATABOARD_INTRO = 'wizard_databoard_intro',
	WIZARD_FIRST = 'wizard_first',
	DESIGNER_ADD_TO_LOOP_DATABOARD = 'designer_add_to_loop_databoard',
	DESIGNER_ADD_TO_REPORT = 'designer_add_to_report',
	DESIGNER_CHANGE_DATE_RANGE = 'designer_change_date_range',
	DESIGNER_DRAG_AND_DROP = 'designer_drag_and_drop',
	DESIGNER_INTRO = 'designer_intro',
	DESIGNER_MOVE_BLOCK = 'designer_move_block',
	DESIGNER_RESIZE_BLOCK = 'designer_resize_block',
	DESIGNER_SELECT_VISUALIZATION_TYPE = 'designer_select_visualization_type',
	DESIGNER_SHARABLE_LINK = 'designer_sharable_link',
	DESIGNER_MORE_OPTION = 'designer_more_option',
	REPORTS_ADD_DATA_ELEMENT = 'reports_add_data_element',
	REPORTS_ADD_DATA_STORY = 'reports_add_data_story',
	REPORTS_ADD_NOTE = 'reports_add_note',
	REPORTS_CHANGE_DATA_STORY_SETTINGS = 'reports_change_data_story_settings',
	REPORTS_CREATE_NEW_SLIDE = 'reports_create_new_slide',
	REPORTS_DOWNLOAD_PDF = 'reports_download_pdf',
	REPORTS_FAVORITE = 'reports_favorite',
	REPORTS_FIRST_PREVIEW = 'reports_first_preview',
	REPORTS_PLAN_PERFORMER = 'reports_plan_performer',
	REPORTS_PREVIEW_POPUP_EDIT = 'reports_preview_popup_edit',
	REPORTS_PREVIEW_POPUP_SHARE = 'reports_preview_popup_share',
	REPORTS_REORDER_SLIDES = 'reports_reorder_slides',
	REPORTS_SELECT_DATA_ELEMENT = 'reports_select_data_element',
	REPORTS_SELECT_DATA_STORY = 'reports_select_data_story',
	REPORTS_PAGELESS_ADD_BLOCKS = 'reports_pageless_add_blocks',
	REPORTS_PAGELESS_ADD_COLUMN = 'reports_pageless_add_column',
	REPORTS_PAGELESS_CUSTOMIZE = 'reports_pageless_customize',
	REPORTS_PAGELESS_SHARE = 'reports_pageless_share',
	REPORTS_PAGELESS_VIEW_SWITCH = 'reports_pageless_view_switch',
	REPORTS_PRESENT = 'reports_present',
	RECENTLY_DELETED = 'recently_deleted',
	GENIE_CLIENT_SELECTOR = 'genie_client_selector',
	GENIE_CUSTOMIZE = 'genie_customize',
	GENIE_SKILLS = 'genie_skills',
	GENIE_ARTIFACT_EDIT = 'genie_artifact_edit',

	// CONFIRM POPUPS - dont't show again
	EXIT_DESIGNER = 'exit_designer',
}
